/**
 * #4003 — regras de tela da lista de variações da campanha.
 *
 * Estão aqui, e não soltas no CampaignModal, porque o modal tem mais de mil
 * linhas e não é testável em unidade. Foi exatamente numa dessas regras que
 * escapou o defeito do label: o campo passou a se chamar `messages.0` e o
 * componente derivava o rótulo do nome do campo, imprimindo
 * "campaigns.dialog.form.messages.0" na tela.
 */

/** Uma variação em branco — o que a tela mostra quando não há nada cadastrado. */
export const VARIACAO_VAZIA = "";

/**
 * Lista pronta para a tela, a partir do que veio da API.
 *
 * O JSONB chega ora como array, ora como string. E lista vazia precisa virar
 * um item em branco: sem isso a tela abriria SEM nenhum campo de mensagem, e a
 * pessoa não teria onde digitar.
 */
export function normalizarMensagens(valor) {
  let lista = valor;

  if (typeof valor === "string") {
    try {
      lista = JSON.parse(valor || "[]");
    } catch {
      lista = [];
    }
  }

  if (!Array.isArray(lista)) lista = [];

  return lista.length > 0 ? lista : [VARIACAO_VAZIA];
}

/**
 * Rótulo de cada campo da lista.
 *
 * O primeiro é "a" mensagem da campanha; os demais são variações do mesmo
 * texto (é isso que evita o WhatsApp tratar o disparo como spam). A numeração
 * mostrada é 1-based e começa no 2, porque a variação 1 é a própria mensagem.
 *
 * Recebe o tradutor por parâmetro para poder ser testado sem o i18n montado.
 */
export function rotuloDaVariacao(index, t) {
  if (index === 0) return t("campaigns.dialog.form.message");
  return `${t("campaigns.dialog.form.messageVariation")} ${index + 1}`;
}

/**
 * A campanha tem mensagem para enviar?
 *
 * A primeira variação é obrigatória: sem nenhum texto, o disparo sortearia uma
 * string vazia e os contatos receberiam mensagem em branco.
 */
export function temMensagemPrincipal(lista) {
  if (!Array.isArray(lista)) return false;
  return typeof lista[0] === "string" && lista[0].trim() !== "";
}

/**
 * Pode remover esta variação?
 *
 * A primeira, nunca — é a mensagem da campanha. E nada é editável quando a
 * campanha já saiu (o modal fica em modo leitura).
 */
export function podeRemoverVariacao(index, campanhaEditavel) {
  return index > 0 && !!campanhaEditavel;
}

/**
 * O que vai para a API: descarta os campos que ficaram em branco.
 *
 * A pessoa pode clicar em "adicionar variação" e desistir de preencher —
 * gravar isso faria o sorteio cair num texto vazio.
 */
export function prepararParaSalvar(lista) {
  if (!Array.isArray(lista)) return [];
  return lista
    .filter(item => typeof item === "string" && item.trim() !== "")
    .map(item => item.trim());
}
